<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/10/2020
  -->

<template>

	<div class="coaching-process-list-root">
		<PagerTable
			ref="pagerTable"
			:dataArray="processList"
			:analytics-props="analyticsPropsMethod()"
			@onLoadMore="onLoadMore">

			<template #items-container="{dataArray}">
				<div class="row mx-0">
					<CoachingProcessListItem
						v-for="(item, index) in dataArray" :key="index"
						class="col-lg-4 col-sm-12 col-md-6"
						:program="item"
						:index="index"
						@click="openDetails(item)"/>
				</div>
			</template>

			<template #empty-view>
				<div class="text-center overflow-y">
					<div class="d-flex justify-content-center mb-5">
						<div shadow="never" style="width: 40%;">
							<img :src="require('@/assets/images/project_empty.png')" style="width: 100%;"/>
						</div>
					</div>
					<h2 class="mb-4">Your active coaching clients will be shown here.</h2>
					<h4 class="">Create your coaching program and invite your first client to get started.</h4>
					<div class="my-5">
						<qw-button type="primary"
								   class="font-size-4 py-3 px-5"
								   @click="onCreateProgramClicked">
							Create coaching program
						</qw-button>
					</div>
					<div class="mx-auto col-md-6 mb-4">Each client whom you've invited to a coaching program will be shown here so you can keep track of their progress, homework, notes, coaching sessions, payments and more. Your clients can access their program from a secure personal client portal.</div>

				</div>
			</template>



		</PagerTable>
	</div>
</template>

<script>

import CoachingProcessListItem from "@/core/modules/coach/Coaching/Processes/CoachingProcessItemView.vue";
import PagerTable from "@/core/components/Data/PagerTable.vue";
import BasePagerView from "@/core/components/Data/BasePagerView.vue";

export default {
	name: "CoachingProcessList",
	components: {PagerTable, CoachingProcessListItem},
	extends: BasePagerView,

	data(){
		return {
			processList: []
		}
	},

	methods: {
		getTableView(pagerKey) {
			return this.$refs.pagerTable
		},
		getDataField(pagerKey) {
			return this.processList
		},

		async dataPagerProvider() {
			return this.$dataManager.getCoachingProcessesPager(12)
		},

		async openDetails(coachingProgramItem){
			let _ = this.$analyticManager.trackEvent("Open coaching process clicked", {program_name: coachingProgramItem.name, client_name: coachingProgramItem.headingTitle, id: coachingProgramItem.id, ...this.analyticsPropsMethod()})
			console.log("coachingProgramItem clicked: ", coachingProgramItem)
			return this.go("ProcessDetailsCoach", {programId: coachingProgramItem.id})
		},

		async onCreateProgramClicked(){
			let _ = this.$analyticManager.trackEvent("Create coaching program clicked", this.analyticsPropsMethod())
			await this.go("CoachingMainCoach", {category: "templates"}, {wizard: "program"})
		},

		analyticsPropsInternal(){
			return {
				category: "Process list"
			}
		}
	},
}
</script>

<style lang="scss">
	.coaching-process-list-root{
		//height: calc(100vh - 76px);
	}
</style>
